module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DModal', {
    attrs: {
      "isBgOverlay": true,
      "show-close": false
    }
  }, [_c('div', {
    staticClass: "do-modal",
    attrs: {
      "slot": "insertComponent"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "do-modal__header"
  }, [_c('h2', [_vm._v("Grupper med pædagogoptælling")]), _vm._v(" "), _c('div', {
    staticClass: "icon__bg-circle ww-modal__header__close",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "do-modal__body"
  }, [_c('section', {
    staticClass: "modal-section"
  }, [_c('h4', [_vm._v("Grupper uden forberedelsesfaktor")]), _vm._v(" "), _c('p', {
    staticClass: "marg-1-bottom"
  }, [_vm._v("\n          For disse grupper sættes\n          forberedelsesfaktoren\n          til 0, så undervisningstimer ikke automatisk udløser forberedelsestid.\n          "), _c('a', {
    attrs: {
      "href": "https://docendohelp.crisp.help/da/article/optaelling-af-timer-pa-paedagoger-arsnorm-1ww8w39",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("Læs evt. mere i den uddybende vejledning")]), _vm._v(".\n        ")]), _vm._v(" "), _c('DoFiltersFilter', {
    attrs: {
      "title": 'Grupper',
      "tags": _vm.tags,
      "selectedTags": _vm.selectedTags,
      "numberOfSelectedTagsToShow": 6,
      "placeholder": 'Vælg grupper'
    },
    on: {
      "select": _vm.toggleTag,
      "clear": _vm.clearTags
    }
  })], 1), _vm._v(" "), _c('section', {
    staticClass: "modal-section marg-2-top"
  }, [_c('h4', [_vm._v("Grupper hvor arbejdstid tælles som sum af alle skemalagte timer")]), _vm._v(" "), _c('p', {
    staticClass: "marg-1-bottom"
  }, [_vm._v("\n          For disse grupper tælles\n          skemalagt arbejdstid\n          som summen af alle skemalagte timer (fx SFO-tid, UV-tid, vikartimer osv.) i stedet for backendens beregnede arbejdstid.\n        ")]), _vm._v(" "), _c('DoFiltersFilter', {
    attrs: {
      "title": 'Grupper',
      "tags": _vm.tags,
      "selectedTags": _vm.selectedTagsSumWorkHours,
      "numberOfSelectedTagsToShow": 6,
      "placeholder": 'Vælg grupper'
    },
    on: {
      "select": _vm.toggleTagSumWorkHours,
      "clear": _vm.clearTagsSumWorkHours
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "do-modal__footer"
  }, [_c('button', {
    staticClass: "do-bttn marg-1-right",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("Annuller")]), _vm._v(" "), _c('button', {
    staticClass: "do-bttn do-bttn--submit",
    class: {
      'do-bttn--submit--loading': _vm.isSaving
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.common.save')) + "\n      ")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-70d41f56!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AssignHours/ModalPedagogicalSetting.vue
// module id = 2003
// module chunks = 1